import { gql } from '@apollo/client';

export const GET_WORK_ORDERS_DETAILS = gql`
  query getWorkOrderDetails($externalWorkOrderId: ID) {
    getWorkOrderDetails(externalWorkOrderId: $externalWorkOrderId) {
      fulfillmentAgreementId
      products {
        id
        existing
        kind
        name
        characteristics {
          name
          value
        }
      }
    }
  }
`;

export const GET_WORK_ORDERS = gql`
  query getWorkOrders {
    getWorkOrders {
      workOrders {
        workOrder {
          externalWorkOrderId
          workOrderType {
            workOrderType
          }
          schedule {
            from
            to
          }
        }
      }
    }
  }
`;

export const GET_FIBER_INSTALLATION_DATES = gql`
  query getAvailableInstallationDates($input: GetAvailableInstallationDatesInput) {
    getAvailableInstallationDates(input: $input) {
      timezone
      schedules {
        to
        from
      }
      serviceableStatus {
        isServiceable
        estimatedServiceableDate
        message
      }
    }
  }
`;

export const GET_SATELLITE_INSTALLATION_DATES = gql`
  query getAvailableInstallationDates($input: GetAvailableInstallationDatesInput) {
    getAvailableInstallationDates(input: $input) {
      timezone
      schedules {
        to
        from
      }
    }
  }
`;

export const UPSERT_WORK_ORDER_SCHEDULE = gql`
  mutation upsertWorkOrderSchedule($input: UpsertWorkOrderScheduleInput!) {
    upsertWorkOrderSchedule(input: $input) {
      externalWorkOrderId
      success
    }
  }
`;
